import { useState, useEffect } from "react"; 
import { Modal, message, Avatar, Spin } from "antd-v5";
import { useTranslation } from "react-i18next";
import Api from "../../shared/Api";
import { ApiEndpoints, getDefaultImage, imageType } from "../../shared/Common";
import CreateOrEditSchoolTraining from "../createOrEditSchoolTraining/CreateOrEditSchoolTraining";
import { EqDisciplineType } from "../../shared/enums";
import { useAuthState } from "../../context/Context";
import React from "react";
import { IEventType, IProductOPtions } from "../../shared/interfaces/schoolTraining/IGetSchoolTrainingDto";
import { IEqUiSelectModel, IGetPopulation } from "../../shared/interfaces/ILocationDto";
import { ISchoolStudents, ITrainerOption } from "../../shared/interfaces/ridingCourse/IRidingCourse";
import { GetSchoolStudentsDto } from "../../shared/interfaces/schoolTraining/school";
import { ISelectOption } from "../../shared/Interfaces";
import { IStudentHorseList } from "../../shared/interfaces/horse/IHorses";

const SchoolPrivateTrainingModal = ({ trainingId, visible, onClose }: any) => {
  const userDetails: any = useAuthState();
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(true);
  const [selectedTraining, setSelectedTraining] = useState<any>(null);
    const [areas, setAreas] = React.useState<IEqUiSelectModel[]>([]);
    const [weekDays, setWeekDays] = React.useState<IEqUiSelectModel[]>([]);
    const [studentHorsesList, setStudentHorsesList] = React.useState<IStudentHorseList[]>([])
    const [schoolStudents, setSchoolStudents] = useState<ISchoolStudents[]>([]);
  const [population, setPopulation] = React.useState<IGetPopulation[]>([]);
  const [groupPopulation, setGroupPopulation] = React.useState<IGetPopulation[]>([]);
    const [schoolEventTypes, setSchoolEventTypes] = React.useState<IEventType[]>([]);
    const [trainersOptions, setTrainersOptions] = useState<ISelectOption[]>([]);

  useEffect(() => {
    if (trainingId && visible) {
      fetchAllData();
      fetchSchoolTrainers();
    }
  }, [trainingId, visible]);

  const fetchSchoolTrainers = async () => {
    try {
      const response = await Api.get(ApiEndpoints.SchoolGetTrainers);
      if (response.status === 200) {
        const trainers = response.data.map((trainer: any) => ({
          key: trainer.key,
          value: `${trainer.firstName} ${trainer.lastName}`,
          label: trainer.firstName,
          icon: (
            <Avatar
              size={30}
              src={trainer.userImage?.url || getDefaultImage(imageType.trainer)}
            />
          ),
        }));

        setTrainersOptions([
          {
            key: userDetails.key,
            value: userDetails.name,
            label: userDetails.name,
            icon: (
              <Avatar
                size={30}
                src={userDetails.userImage?.url || getDefaultImage(imageType.trainer)}
              />
            ),
          },
          ...trainers,
        ]);
      }
    } catch (error) {
      console.error("Error fetching trainers:", error);
      message.error("Failed to load trainers.");
    }
  };

  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [
        trainingResponse,
        schoolStudentsResponse,
        // populationResponse,
        groupPopulationResponse,
        areasResponse,
        weekDaysResponse,
      ] = await Promise.all([
        Api.get(`${ApiEndpoints.SchoolTraining.GetSchoolTrainingsById}/${trainingId}`),
        Api.get(ApiEndpoints.SchoolStudents.GetSchoolStudentsGroupDto),
        // Api.get(ApiEndpoints.eventGetPopulation),
        Api.get(ApiEndpoints.eventGetGroupPopulation),
        Api.get(ApiEndpoints.Location.GetUserAreaOptions),
        Api.get(ApiEndpoints.eventGetWeekDays),
      ]);

      const studentsData = schoolStudentsResponse.data;
      const studentHorsesListOptions = studentsData.map((item: any) => {
        const horseListObj = [
          ...item.user.horses.map((h: any) => ({
            key: h.id,
            value: h.name,
            label: h.name
          })),
          ...item.school.horses.map((h: any) => ({
            key: h.id,
            value: h.name,
            label: h.name
          }))
        ];
        return { key: item.key, horseList: horseListObj };
      });

      setSelectedTraining(trainingResponse.data);
      setSchoolStudents(studentsData);
      setStudentHorsesList(studentHorsesListOptions);
      // setPopulation(populationResponse.data);
      setGroupPopulation(groupPopulationResponse.data);
      setAreas(areasResponse.data);
      setWeekDays(weekDaysResponse.data);
      setSchoolEventTypes([
        { key: EqDisciplineType.Dressage, value: EqDisciplineType[EqDisciplineType.Dressage] },
        { key: EqDisciplineType.Jumping, value: EqDisciplineType[EqDisciplineType.Jumping] },
        { key: EqDisciplineType.Open, value: EqDisciplineType[EqDisciplineType.Open] },
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
      message.error("Failed to load training data.");
    }
    setLoading(false);
  };

  const handleOnUpdateTraining = (updatedTraining: any) => {
    console.log("Updated Training:", updatedTraining);
    onClose();
  };
    const emptyProductOptions: IProductOPtions = {
        createOptions: [],
        editOptions: [],
    };

  return (
    <Modal
      title={t("training")}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={"85vw"}
    >
      {loading ? (
        <Spin style={{ width: "100%" }} />
      ) : (
        selectedTraining &&
        <CreateOrEditSchoolTraining
          onActivityTitleChange={() => {}}
          eventData={selectedTraining}
          eventKey={selectedTraining?.key}
          eventTypes={schoolEventTypes}
          trainersOptions={trainersOptions}
          areas={areas}
          weekDaysData={weekDays}
          groupPopulation={groupPopulation}
          schoolStudents={schoolStudents}
          studentHorsesList={studentHorsesList}
          onCreateOrUpdateSchoolTraining={handleOnUpdateTraining}
          isStudent={false}
          products={[]}
          productOptions={emptyProductOptions}
        />
      )}
    </Modal>
  );
};

export default SchoolPrivateTrainingModal;
